import {
  Avatar,
  BottomNavigation,
  BottomNavigationAction,
  createTheme,
  Paper,
  ThemeProvider,
} from "@mui/material";
import { useState, type FC } from "react";
import { type SideBarButton } from "../sidebar/SideBar";

import { imageURL } from "@shared/helpers/constants";
import clsx from "clsx";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/UserProvider";
import ProfilePage from "../../pages/profile-page/ProfilePage";
import "./Footer.scss";

interface FooterProps {
  buttons: SideBarButton[];
}

const filtered = [
  "סטטיסטיקות",
  "בקשות",
  "קבוצות מאורגנות",
  "מערכת חגי",
  "הרשאות",
];

const theme = createTheme({
  palette: {
    primary: {
      main: "#00b4d8",
    },
    secondary: {
      main: "#05204CF2",
    },
  },
});

const Footer: FC<FooterProps> = ({ buttons }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [profilePageOpen, setProfilePageOpen] = useState<boolean>(false);
  const [bgcolor, setBgcolor] = useState<string>("");
  const { currentUser } = useUser();
  return (
    <ThemeProvider theme={theme}>
      <Paper elevation={4}>
        <BottomNavigation
          value={pathname}
          sx={{ overflowX: "auto", alignSelf: "center" }}
          onChange={(_, value) => navigate(value)}
        >
          {buttons
            .filter(({ title }) => !filtered.includes(title))
            .map(({ title, icon, navigate, moreRoutes }) => (
              <BottomNavigationAction
                className={clsx(
                  moreRoutes?.some((route) => pathname.includes(route)) &&
                    "Mui-selected",
                )}
                value={navigate}
                key={title}
                label={title}
                icon={icon}
                sx={{ padding: 0, minWidth: "unset", color: "#05204CBF" }}
              />
            ))}
          <BottomNavigationAction
            onClick={() => setProfilePageOpen((prev) => !prev)}
            label={currentUser?.name}
            icon={
              <Avatar
                onError={() => setBgcolor("#05204CBF")}
                sx={{ width: 23, height: 23, fontSize: "small", bgcolor }}
                src={
                  currentUser?.profileImageId
                    ? imageURL(currentUser.profileImageId)
                    : "/unknown.png"
                }
              />
            }
            sx={{ padding: 0, minWidth: "unset", color: "#05204CBF" }}
          />
        </BottomNavigation>
      </Paper>
      <ProfilePage open={profilePageOpen} setOpen={setProfilePageOpen} />
    </ThemeProvider>
  );
};

export default Footer;
